export const MAP1 = [
  {
    hashtag: "#1",
    title:
      "Hands on workshop on prosthetically oriented 3D implant position –  Practical workshop on conventional and guided implant planning; design of surgical guides and implant placement",
    text: "Digitalization is a topic of major interest in all fields of dentistry. The precise implant position is decisive for the esthetic outcome and long-term stability. In the workshop we discuss and train, how to find the ideal position for implants in the esthetic zone and the backward planning of complex implant cases. The use of drill guides is not an autopilot for implant placement and requires knowledge about potential pitfalls.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1: "• What do I need, for a digital implant planning?",
    text2: "• What is the ideal implant position and how to plan?",
    text3: "• Guided esthetics – what does it mean?",
    text4: `• Which circumstances can influence my precision?`,
    text5: `• What are the advantages of backwards planning?`,
  },
  {
    hashtag: "#2",
    title:
      "Immediate implant placement for multiple tooth replacement. Indications, limitations, how to plan it?",
    text: "Today patients are presented with a variety of clinical situation such as edentulous spans and sites requiring tooth extraction. This workshop will focus on sites that require extraction of multiple teeth and clinical decisions to follow in terms of implant rehabilitation. In decision making, issues like atraumatic extraction methods, socket debridement, socket preparation, grafting and regenerative materials, implant diameter and length, proximity to vital anatomical structures,  and  fixed provisionals will be discussed.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1:
      "• To prepare a site for immediate placement where there are defects",
    text2:
      "• The determinates that permit immediate load-functional and nonfunctional loading",
    text3: "•	What methods are utilized for provisionalization",
  },
  {
    hashtag: "#3",
    title: "Case planning workshop",
    text: "The case planning workshops will encompass the detailed analysis of a patient situation foreseen for a rehabilitation with fixed restorations, including the (immediate or early/delayed) placement of implants. The analysis will include an in-depth analysis of the prognosis of teeth from a periodontal, endodontic and tooth-substance-related point of view. Different treatment plans will be developed in subgroups and discussed with all.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1:
      "• To learn the structured approach of case analysis and definition of single tooth prognosis",
    text2:
      "• Discuss the ideal time-point for the implant placement in the presented case",
    text3: "• Development of several treatment options for the rehabilitation",
    text4:
      "• Learn the detailed approach to achieve the treatment goal, including the treatment phases (diagnostic phase, hygienic phase, surgical phase, restorative phase)",
  },
  {
    hashtag: "#4",
    title:
      "Hands on workshop on immediate implant placement in single tooth replacement. Indications, limitations, how to do it?",
    text: "Placing implants immediately into the fresh extraction socket has become more and more popular. Going along with that, the number of implant failures as well as esthetic disappointments increased as well. As it turned out, tiny little inobservances during operation and restauration may have a high impact on the final result.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1:
      "• What are the indications for immediate implant placement and restoration?",
    text2: "• What are the limitations of this technique?",
    text3: "• How to avoid failures",
    text4: `• How to deal with complications`,
  },
];

export const MAP2 = [
  {
    hashtag: "#5",
    title: "Workshop on management of bone defects with bone blocks",
    text: "The use of bone blocks is one of the available methods for obtaining bone augmentations of the deficient alveolar ridge. In complex situations this technique allows predictable outcomes because of the space making effect of the blocks. Selection of indications and the correct harvesting technique are of crucial steps needed to achieve successful results.",

    comingsoon: "",
    subtitle: "Learning objectives",
    text1: "• Understand the clinical indications to bone blocks",
    text2:
      "• Get familiar with the anatomy and the surgical technique for mandibular bone harvesting",
    text3:
      "• Explore the new possibilities with allogenic and xenogeneic blocks",
    text4: "",
  },
  {
    hashtag: "#6",
    title: "GBR with Xenograft bone in daily implant practice",
    text: "Hard and soft tissue grafting is frequently required when implants are placed in an ideal prosthetically driven position. Bone grafting can be performed through several different techniques. Defect geometry and entity represent two critical factors for technique and materials selection. This presentation will include clinical cases and tips & tricks for the most common procedures of bone augmentation, ready to apply in daily clinical practice.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1: "• Understand the basic GBR biologic principles",
    text2:
      "• Be ready to apply a decisional tree regarding bone substitutes selection",
    text3:
      "• Improve techniques of GBR through soft tissue passivation, membrane stabilization, and primary flap closure suturing",
    text4: "Organized by Straumann",
  },
  {
    hashtag: "#7",
    title: "Case planning workshop - Surgical",
    text: "A detailed analysis of a patient with a failing fixed restoration supported also by failing implants will be performed. The analysis will include an in-depth analysis of the prognosis of remaining teeth and implants. Different treatment plans will be developed in subgroups and discussed with all.",
    comingsoon: "",
    subtitle: "",
    text1: "",
    text2: "",
    text3: "",
    text4: "",
  },
  {
    hashtag: "#8",
    title: "Hands on workshop on management of bone defects",
    text: "The use of Guided Bone Regeneration associated to non-autogenous scaffolds in combination to particulate autogenous bone grafts, as well as bone block augmentation constitutes the standard of care of bone augmentation in all alveolar defects with or without implants. Choosing the correct therapeutic approach in the selected indications, with the appropriate biomaterials plays a crucial role in obtaining positive outcomes in advanced augmentation procedures.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1:
      "• To understand the biological principle of GBR and bone block augmentations in its clinical applicability",
    text2:
      "•	Learn tips and tricks on how to perform bone augmentation in severe defects",
    text3:
      "•	Manage the soft tissues during augmentation procedure in vertical ridge augmentation",
    text4: "• Learn how to avoid complications",
  },
];

export const MAP3 = [
  {
    hashtag: "#9",
    title: "Hands on workshop on digital workflow in managing bony defects",
    text: "The use of new techniques like digital planning has enhanced the possibility of solving even severe vertical and horizontal alveolar defects by using prefabricated blocks and titanium meshes. Nevertheless, these techniques require a correct application procedure and thus being critically sensitive for failures.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1: "•	To understand the principle of digitally planed augmentation aids",
    text2:
      "• Learn tips and tricks on how to perform bone augmentation using digital techniques",
    text3:
      "• Manage the soft tissues during augmentation procedure in vertical ridge augmentation",
    text4: "•	Learn how to avoid and manage complications",
  },
  {
    hashtag: "#10",
    title: "Removable implant supported concepts; Selection of attachments",
    text: "Removable implant concepts are used and investigated over decades, but which implant attachment fit to my patient? Recent literature will give us many answers on patient satisfaction, maintenance intensity and survival rates of different attachment systems.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1: "• Advantages and disadvantages of different removable concepts",
    text2:
      "• How to combine remaining dentition and implants in a removable concept",
    text3: "• Which concept has the best survival rate over time?",
    text4: "•	How to deal with complications",
  },
  {
    hashtag: "#11",
    title: "Case planning workshop - Prosthetically focused",
    text: "Planning of another patient case situation with a hard and soft tissue defect to be rehabilitated along with the general rehabilitation. The approach learned in WS 4 will be continued, now also focusing on different options to rehabilitate the defect with surgical and/ or restorative means.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1: "• Train the structured approach in case analysis and planning",
    text2: "• Discuss different options for defect resolution",
    text3: "•	Learn about the possibilities and limitations of pink ceramics",
    text4:
      "•	Train the detailed approach to achieve the treatment goal, including the treatment phases (diagnostic phase, hygienic phase, surgical phase, restorative phase)",
  },
  {
    hashtag: "#12",
    title:
      "Hands on workshop on adhesive cementation of different ceramic restorations to Ti-base; polishing of monolithic restorations. Management of complications",
    text: "In this workshop participants will learn all about the new restorative materials, such as different ceramics and hybrid materials and their indications for implant-supported restorations. The indications of monolithic and micro-veneered restorations will be discussed. The adhesive cementation of monolithic restorations to titanium base abutments will be trained. Complication management such as polishing of monolithic materials will be trained.",
    comingsoon: "",
    subtitle: "Learning objectives",
    text1:
      "• Learn about today’s material options for monolithic and micro-veneered implant restorations",
    text2:
      "• Learn the step-by-step approach for the adhesive cementation of different monolithic crowns",
    text3:
      "• Learn about surface treatment (polishing) of monolithic crowns and FDPs",
    text4: ``,
  },
];
